import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resourceApi } from '../api/resourceApi';
import { toast } from 'react-hot-toast';

export const useUpdateResource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      resourceApi.updateResource(id, data),
    onSuccess: () => {
      toast.success('Resource updated successfully');
      queryClient.invalidateQueries({ queryKey: ['resources'] });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to update resource');
    },
  });
};
